import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	dSearchValue: {}, // data table search value
	pSearchValue: {}, // page search value
	clickedItem: {},
	page: {},
	limit: {},
	socketStatus: 0,
	openTab: null,
	inbox: 0,
	identity: 0,
	delegation: 0,
	participated: 0,
	upcoming: 0,
	inprogress: 0,
	completed: 0,
	showPropertyModal: false,
};

const mainSlice = createSlice({
	name: 'main',
	initialState,
	reducers: {
		setDataTableSearchKey(state, action) {
			state.dSearchValue = {
				...state.dSearchValue,
				...action.payload.dSearchValue,
			};
		},
		removeDataTableSearchKey(state, action) {
			const obj = { ...state.dSearchValue };
			const filteredValue = Object.fromEntries(Object.entries(obj).filter(([key]) => !key.startsWith(action.payload.currentPathName)));

			state.dSearchValue = filteredValue;
		},
		setDataTableReset(state) {
			state.dSearchValue = {};
			state.pSearchValue = {};
			state.clickedItem = {};
			state.page = {};
			state.limit = {};
		},
		setScrollIntoTableRow(state, action) {
			state.clickedItem = action.payload.clickedItem;
		},
		setDataTableInfo(state, action) {
			state.page = action.payload.page;
			state.limit = action.payload.limit;
		},
		setPageSearchKey(state, action) {
			state.pSearchValue = action.payload.searchString;
		},
		setSocketReducer(state) {
			state.socketStatus = state.socketStatus + 1;
		},
		setOpenTab(state, action) {
			state.openTab = action.payload;
		},
		setInbox(state, action) {
			state.inbox = action.payload.inbox;
		},
		setIdentity(state, action) {
			state.identity = action.payload.identity;
		},
		setDelegation(state, action) {
			state.delegation = action.payload.delegation;
		},
		setUpcoming(state, action) {
			state.upcoming = action.payload.upcoming;
		},
		setParticipated(state, action) {
			state.participated = action.payload.participated;
		},
		setInprogress(state, action) {
			state.inprogress = action.payload.inprogress;
		},
		setCompleted(state, action) {
			state.completed = action.payload.completed;
		},
		resetMain(state) {
			state.dSearchValue = {};
			state.pSearchValue = {};
			state.clickedItem = {};
			state.page = {};
			state.limit = {};
			state.socketStatus = false;
		},
		setShowPropertyModal(state, action) {
			state.showPropertyModal = action.payload;
		},
	},
});

export const {
	setDataTableSearchKey,
	setDataTableReset,
	setScrollIntoTableRow,
	setDataTableInfo,
	setPageSearchKey,
	setSocketReducer,
	resetMain,
	setOpenTab,
	setInbox,
	setDelegation,
	setUpcoming,
	setParticipated,
	setInprogress,
	setCompleted,
	setIdentity,
	setShowPropertyModal,
	removeDataTableSearchKey,
} = mainSlice.actions;

export default mainSlice.reducer;
